(function () {
    'use strict';

    angular
        .module('app')
        .controller('ItemBulkEditDialogCtrl', ItemBulkEditDialogCtrl);

    ItemBulkEditDialogCtrl.$inject = ['DialogInstance', 'ItemService', 'itemEditState'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for showing item bulk edit.
     */
    function ItemBulkEditDialogCtrl(DialogInstance, ItemService, itemEditState) {
        /* jshint validthis:true */
        var vm = this;
        vm.entity = null;
        vm.entityTemplate = null;
        vm.ok = ok;
        vm.cancel = cancel;
        Object.defineProperty(vm, 'okDisabled', { get: function () { return _.isNil(vm.entity); } });
        vm.itemsToEdit = [];
        vm.itemsThatCannotBeMoved = [];
        vm.itemsToEditCount = 0;
        vm.itemsThatCannotBeMovedCount = 0;

        activate();

        function activate() {
            var itemsToEdit = _.chain(itemEditState).filter({ status: 'ToBeMoved' }).map('item').value();
            var itemsThatCannotBeMoved = _.chain(itemEditState).filter({ status: 'ItemTypeCannotBeMoved' }).map('item').value();
            
            vm.itemsToEdit = ItemService.summariseItemList(itemsToEdit);
            vm.itemsThatCannotBeMoved = ItemService.summariseItemList(itemsThatCannotBeMoved);

            vm.itemsToEditCount = itemsToEdit.length;
            vm.itemsThatCannotBeMovedCount = itemsThatCannotBeMoved.length;
        }

        function ok() {
            DialogInstance.ok(vm.entity);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();